import './CompanyDetails.scss';
import { AppContext } from '../../../../context';
import { BrandString, Guest, Organization, User } from '../../../../types';
import { useContext } from 'react';

interface CompanyDetailsParams {
    recruiter?: User;
    candidate?: Guest;
    organization?: Organization;
    meetAboutCompany?: string | BrandString[];
    meetIntroHeader?: string | BrandString[];
    meetIntroSubheader?: string | BrandString[];
}

const CompanyDetails = ({
    recruiter,
    organization,
    meetAboutCompany,
    meetIntroHeader,
    meetIntroSubheader,
}: CompanyDetailsParams) => {
    const { getValueForBrandStringField, translate } = useContext(AppContext);
    const companyName = organization?.name;
    return (
        <>
            <div className="flexCardBodyLeftHeader">
                <img src={recruiter?.profileUrl} alt=""></img>
                <div className="flexCardBodyLeftInterviewer">
                    <span className="flexCardBodyLeftInterviewerName">{recruiter?.givenName}</span>
                    <span className="flexCardBodyLeftInterviewerDescription">{recruiter?.title}</span>
                </div>
            </div>

            <div className="flexCardBodyLeftDescription">
                <h2 className="flexCardBodyLeftDescriptionTitle">{getValueForBrandStringField(meetIntroHeader)}</h2>
                <span className="flexCardBodyLeftDescriptionAbout">
                    {getValueForBrandStringField(meetIntroSubheader)}
                </span>
            </div>

            <div className="flexCardBodyLeftAbout">
                {getValueForBrandStringField(meetAboutCompany) ? (
                    <>
                        <h3 className="flexCardBodyLeftAboutTitle">{`${translate('general:about', {
                            company: companyName,
                        })} `}</h3>
                        <span className="flexCardBodyLeftAboutDescription">
                            {getValueForBrandStringField(meetAboutCompany)}
                        </span>
                    </>
                ) : null}
            </div>
        </>
    );
};

export default CompanyDetails;
